import { render, staticRenderFns } from "./VipPoint.vue?vue&type=template&id=2d1713f8&"
import script from "./VipPoint.vue?vue&type=script&lang=js&"
export * from "./VipPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports